/**
 * Sending a signed-in person on to the app they belong in (ADJ-1022-4).
 *
 * A driver's invitation ends on the Admin Console, the WorkOS environment's
 * default redirect. The console and the Store Portal send a driver on to the
 * Driver App, which has its own session to start: the hint asks it to start
 * that sign-in at once rather than show a second Sign in button. WorkOS still
 * holds the session from a moment ago, so the round trip asks for nothing.
 */

/** The query parameter that asks the Driver App to sign in on arrival. */
export const SIGN_IN_HINT = "signin";

/** The Driver App's address for somebody sent on from another app. */
export function driverAppEntry(base: string): string {
	return new URL(`/?${SIGN_IN_HINT}=1`, base).href;
}

/**
 * True the first time this tab asks under `key`, false after — and false when
 * storage is refused. An automatic sign-in runs through it, so a sign-in that
 * keeps failing stops at a button instead of looping.
 */
export function firstInTab(key: string): boolean {
	try {
		if (window.sessionStorage.getItem(key) !== null) {
			return false;
		}
		window.sessionStorage.setItem(key, "1");
		return true;
	} catch {
		return false;
	}
}
